import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import api from "../../services/api";
import axiosPrivate from "../../services/axios/axiosPrivate";

export const fetchAllUsers = createAsyncThunk('getAllUsers/fetchAllUsers',
  async (_, { rejectWithValue }) => {
    try {
      const url = `${api.getAllUsers}?type=1`
      const response = await axiosPrivate.get(url);
      return response.data.data;
    } catch(error) {
      return rejectWithValue(error?.response?.data?.message || "Unable to connect to server")
    }
  })

const getAllUsersSlice = createSlice({
  name: 'Users',
  initialState: {
    Users: [],
    status: 'idle',
    loading: false,
    error: null
  },
  reducers: {},
  extraReducers: (builders) => {
    builders
      .addCase(fetchAllUsers.pending,
        (state) => {
          state.status = 'loading';
          state.loading = true;
          state.error = null;
        })
      .addCase(fetchAllUsers.fulfilled,
        (state, action) => {
          state.status = 'succeeded';
          state.loading = false;
          state.Users = action.payload;
        })
      .addCase(fetchAllUsers.rejected,
        (state, action) => {
          state.status = 'failed';
          state.loading = false;
          state.error = action.payload;
        }
      )
  }
})

export default getAllUsersSlice.reducer;